<template>
  <div id="app">
    <router-view :key="$route.fullPath" />
    <el-dialog title="提示" :visible.sync="dialogVisible" :close-on-press-escape="false" :close-on-click-modal="false" :show-close="false"  width="30%" style="padding:12px 20px" >
       <div>尊敬的用户：您好！</div>
      <div>
          近期我们注意到部分用户误将此链接认作学习入口，为避免影响您的正常学习，特此温馨提示：您当前访问的链接并非正确的网校学习地址。为保障您的学习权益与账号安全，请您及时联系对应商家获专属学习网址。感谢您的理解与配合，祝您学习顺利！
      </div>
      <div>
        特此通知!
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'
export default {
  name: 'App',
  data() {
    return {
      domain: '',
      defaultTitle: '网校',
      defaultIcon: '',
      dialogVisible: false
    }
  },
  created() {
    this.getDomian()
  },
  watch: {
    '$store.state.user.fans_id': {
      immediate: true,
      handler(fansId) {
        const token = localStorage.getItem('token')
        if (fansId && token) {
          console.log('考勤websocket链接中===>', fansId)
          this.$ws.connect({ userId: fansId })
        }
      }
    }
  },
  methods: {
    ...mapMutations(['saveDomain']),
    getDomian() {
      if (process.env.NODE_ENV === 'production') {
        this.domain = location.host
        // this.domain = 'wx-adia.shkt.online'
      } else {
        this.domain = 'wx-adia.tenghuiketang.com' // 测试环境
        // this.domain = 'wx-adia.shkt.online' // 生产环境
      }
      this.saveDomain(this.domain)
      this.$store.dispatch('getOrgID', this.domain).then((res) => {
        console.log("res===>",res)
        //没有uid提示
        if (!res.uid) {
          this.dialogVisible = true
        }
      })
      this.$store.dispatch('getWebInfo', this.domain).then((data) => {
        // 设置favicon
        document.querySelectorAll("link[rel*='icon']").forEach(item => {
          item.href = data.web_header_icon || this.defaultIcon
        })
        // 设置网站标题
        document.title = data.web_company_name || this.defaultTitle
      })
    }
  },
  updated() {
    window.scroll(0, 0)
  }
}
</script>

<style>
body {
  margin: 0;
  padding: 0;
}

.cursor-pointer {
  cursor: pointer;
}
</style>